import { render, staticRenderFns } from "./AntragsbuchFilter.vue?vue&type=template&id=3c891656"
import script from "./AntragsbuchFilter.vue?vue&type=script&lang=ts"
export * from "./AntragsbuchFilter.vue?vue&type=script&lang=ts"
import style0 from "./AntragsbuchFilter.vue?vue&type=style&index=0&id=3c891656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports